export default "__VITE_ASSET__sbaw$gWu__"